import React from "react";
import { Link } from "gatsby";
import { globalHistory } from "@reach/router";

import Layout from "../../components/layout";
import SEO from "../../components/seo";
import mobileLogo from "../../images/ud-logo.svg";
import desktopLogo from "../../images/ud-logo_w.svg";
import ProductCompareTable from "../../components/ProductCompareTable";
import { Wrap } from "../../components/ServiceEnquiry";
import ogImage from "../../images/cloudPricing-metaImg_TC.png";

const IndexPage = (props) => {
  const { location } = props;
  const [tabValue, setValue] = React.useState("security");
  const [hostname, setHostname] = React.useState("");

  const onClick = (event) => {
    const {
      target: { value },
    } = event;
    setValue(value);
  };

  React.useEffect(() => {
    if (location.host) {
      console.log(location);
      let hn = location.host.includes("com.hk")
        ? "www.udomain.com.hk"
        : "www.udomain.hk";
      setHostname(hn);
    }
  }, [location]);

  const lng = "tc";

  return (
    <Layout>
      <SEO
        title="UD Cloud 雲端服務收費"
        description={
          "UD雲端服務讓你透過網絡按業務需要取得運算資源，了解更多UD有關香港和中國的雲端服務——包括雲端整合託管、自主管理OpenCloud伺服器, 雲端網頁電郵寄存、雲端伺服器及其他雲端方案。"
        }
        image={ogImage}
      />
      <main>
        <div className="page-cloudPricing">
          <div className="gradient"></div>
          <div id="global-navigation" className="global-navigation">
            <div className=" navigation-1stTier ">
              <a href={`https://${hostname}/tc`}>
                <picture>
                  <source
                    srcSet={`${mobileLogo} 1x`}
                    media="(max-width: 414px)"
                  />
                  <img
                    className="logo_ud"
                    srcSet={`${desktopLogo} 2x`}
                    alt="UD"
                  />
                </picture>
              </a>
              <ul className="list_customer ">
                <li>
                  <a
                    href={`https://${hostname}/tc/about/udomain-hong-kong-cloud-security-expert`}
                    className="list_customer-bold "
                  >
                    關於我們
                  </a>
                </li>
                <li>
                  <a
                    href={`https://${hostname}/tc/support`}
                    className="list_customer-bold "
                  >
                    技術支援
                  </a>
                </li>
                <li>
                  <a href="https://8338.hk/#!/login " className="btn_login ">
                    登入
                  </a>
                </li>
                <li>
                  <Link to="/en">EN</Link>
                </li>{" "}
                |
                <li>
                  <Link to="/sc">简</Link>
                </li>
              </ul>
            </div>
            <ul className="list_service ">
              <li>
                <a
                  href="https://www.udomain.com/zh/main/index.php"
                  target="_blank "
                >
                  域名
                </a>
              </li>
              <li>
                <a href={`https://${hostname}/tc`} className="current ">
                  服務
                </a>
              </li>
              <li>
                <a href={`https://${hostname}/tc/solution/china-cloud`}>方案</a>
              </li>
            </ul>
          </div>
          <div className="content-container">
            <div className="header">
              <a href={`https://${hostname}`}>
                <img
                  className="header-udLogo"
                  srcSet={`${desktopLogo} 2x`}
                  alt="UD"
                />
              </a>
              <h1>UD 雲端服務收費</h1>
              <div className="scroll">
                <div className="cloudType-container">
                  <div id="cloudType-cloudSolution" className="cloudType-card">
                    <a
                      href={`https://${hostname}/tc/solution/managed-multi-cloud-solution-one-platform`}
                    >
                      <div className="cloudType-image-container cloudType-cloudSolution"></div>
                    </a>
                    <h2>雲端方案</h2>
                    <p>
                      由UD雲端技術專家根據你的需要，度身訂造適合你的雲端方案
                    </p>
                    <div className="cloudType-serviceListing">
                      <a
                        href={`https://${hostname}/tc/solution/managed-multi-cloud-solution-one-platform`}
                      >
                        <div className="serviceListing-icon serviceListing-multiCloud"></div>
                        雲端整合託管方案
                      </a>
                      <a href={`https://${hostname}/tc/solution/china-cloud`}>
                        <div className="serviceListing-icon serviceListing-chinaCloud"></div>
                        中國雲端服務
                      </a>
                    </div>
                  </div>
                  <div className="cloudType-card">
                    <a
                      href={`https://${hostname}/tc/service/opencloud-server-openstack-instant-setup-asia-hongkong`}
                    >
                      <div className="cloudType-image-container cloudType-openCloud"></div>
                    </a>
                    <h2>自主管理OpenCloud</h2>
                    <p>
                      快速建立OpenStack虛擬伺服器，專為開發者而設。極速連接中港兩地
                    </p>
                    <div className="cloudType-serviceListing">
                      <a
                        href={`https://${hostname}/tc/service/opencloud-server-openstack-instant-setup-asia-hongkong`}
                      >
                        <div className="serviceListing-icon serviceListing-openCloud"></div>
                        OpenCloud - HK
                      </a>
                      <a
                        href={`https://${hostname}/tc/service/opencloud-server-openstack-instant-setup-us`}
                      >
                        <div className="serviceListing-icon serviceListing-openCloud"></div>
                        OpenCloud - US
                      </a>
                    </div>
                  </div>
                  <div className="cloudType-card">
                    <a
                      href={`https://${hostname}/tc/service/cloud-server/linux`}
                    >
                      <div className="cloudType-image-container cloudType-managedCloud"></div>
                    </a>
                    <h2>雲端伺服器</h2>
                    <p>
                      24x7全天候伺服器及寄存服務技術支援，為你打點一切，讓你全力專注業務發展
                    </p>
                    <div className="cloudType-serviceListing">
                      <a
                        href={`https://${hostname}/tc/service/cloud-server/linux`}
                      >
                        <div className="serviceListing-icon serviceListing-cloudServer"></div>
                        雲端伺服器
                      </a>
                      <a
                        href={`https://${hostname}/tc/service/server-dedicated-hongkong`}
                      >
                        <div className="serviceListing-icon serviceListing-dedicatedServer"></div>
                        專屬伺服器
                      </a>
                      <a
                        href={`https://${hostname}/tc/service/server-colocation-hosting`}
                      >
                        <div className="serviceListing-icon serviceListing-serverColocation"></div>
                        伺服器托管
                      </a>
                      {/* <a href={`https://${hostname}/tc/service/cloud-storage-secure-encrypted-backup`}>
                        <div className="serviceListing-icon serviceListing-cloudStorage"></div>
                        雲端儲存
                      </a> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <span id="allCloudService" className="anchor"></span>
            <div className="allCloudService">
              <h3>所有雲端服務收費</h3>
              <div className="allCloudService-container">
                <a
                  href={`https://${hostname}/tc/solution/managed-multi-cloud-solution-one-platform`}
                  className="allCloudService-grp"
                >
                  <div className="allCloudService-icon-container allCloudService-icon-multiCloud"></div>
                  <div className="allCloudService-desc">
                    <h4>雲端整合託管方案</h4>
                    <p>跨國企業系統， 工程師24x7全天候支援</p>
                  </div>
                </a>
                <a
                  href={`https://${hostname}/tc/solution/china-cloud`}
                  className="allCloudService-grp"
                >
                  <div className="allCloudService-icon-container allCloudService-icon-chinaCloud"></div>
                  <div className="allCloudService-desc">
                    <h4>中國雲端服務</h4>
                    <p>利用UD專業網絡服務開拓中國市場</p>
                  </div>
                </a>
                <a
                  href={`https://${hostname}/tc/service/opencloud-server-openstack-instant-setup-asia-hongkong`}
                  className="allCloudService-grp"
                >
                  <div className="allCloudService-icon-container allCloudService-icon-openCloud"></div>
                  <div className="allCloudService-desc">
                    <h4>OpenCloud</h4>
                    <p>專為開發者而設的自主管理控制平台</p>
                  </div>
                </a>
                <a
                  href={`https://${hostname}/tc/service/cloud-server/linux`}
                  className="allCloudService-grp"
                >
                  <div className="allCloudService-icon-container allCloudService-icon-cloudServer"></div>
                  <div className="allCloudService-desc">
                    <h4>雲端伺服器</h4>
                    <p>適合電子商務及應用程式安全使用</p>
                  </div>
                </a>
                <a
                  href={`https://${hostname}/tc/service/server-dedicated-hongkong`}
                  className="allCloudService-grp"
                >
                  <div className="allCloudService-icon-container allCloudService-icon-dedicatedServer"></div>
                  <div className="allCloudService-desc">
                    <h4>專屬伺服器</h4>
                    <p>專業網絡工程人員為你設計、架設和管理，令你無後顧之憂</p>
                  </div>
                </a>
                <a
                  href={`https://${hostname}/tc/service/server-colocation-hosting`}
                  className="allCloudService-grp"
                >
                  <div className="allCloudService-icon-container allCloudService-icon-serverColocation"></div>
                  <div className="allCloudService-desc">
                    <h4>伺服器托管</h4>
                    <p>為你的伺服器特設安全、穩定的環境和設備</p>
                  </div>
                </a>
                <a
                  href={`https://${hostname}/tc/service/cloud-storage-secure-encrypted-backup`}
                  className="allCloudService-grp"
                >
                  <div className="allCloudService-icon-container allCloudService-icon-serverColocation"></div>
                  <div className="allCloudService-desc">
                    <h4>雲端儲存</h4>
                    <p>在中國和世界各地加密伺服器安全備份資料</p>
                  </div>
                </a>
                <a
                  href={`https://${hostname}/tc/domain-name-search-registration`}
                  className="allCloudService-grp"
                >
                  <div className="allCloudService-icon-container allCloudService-icon-domainRegistration"></div>
                  <div className="allCloudService-desc">
                    <h4>域名登記</h4>
                    <p>UD提供涵蓋不同範疇的域名種類供你選擇</p>
                  </div>
                </a>
                <a
                  href={`https://${hostname}/tc/service/cloud-hosting/hongkong`}
                  className="allCloudService-grp"
                >
                  <div className="allCloudService-icon-container allCloudService-icon-cloudHosting"></div>
                  <div className="allCloudService-desc">
                    <h4>雲端寄存</h4>
                    <p>適合中小企發展香港業務</p>
                  </div>
                </a>
                <a
                  href={`https://${hostname}/tc/service/cloud-email-hosting-hong-kong`}
                  className="allCloudService-grp"
                >
                  <div className="allCloudService-icon-container allCloudService-icon-cloudEmail"></div>
                  <div className="allCloudService-desc">
                    <h4>雲端電郵</h4>
                    <p>香港及中國首屈一指電郵寄存服務，設有24x7技術支援</p>
                  </div>
                </a>
              </div>
              <a
                href={`https://${hostname}/tc/about/why-udomain`}
                className="btn-white"
              >
                為何選擇 UD Cloud ?
              </a>
              <a
                href={`https://${hostname}/tc/service/what-is-cloud-computing-service`}
                className="btn-blue"
              >
                甚麼是雲端運算？
              </a>
            </div>

            <div className="section-value">
              <div className="content-container">
                <h3>我們的信念</h3>
                <div className="graphic-value-container">
                  <div className="graphic-value">
                    <div className="image-container image-service" />
                    <p>貼心服務</p>
                  </div>
                  <div className="graphic-value">
                    <div className="image-container image-security" />
                    <p>網絡安全</p>
                  </div>
                  <div className="graphic-value">
                    <div className="image-container image-speed" />
                    <p>強勁網速</p>
                  </div>
                </div>
                <div className="text-value-container">
                  <div>
                    <h4>貼心服務</h4>
                    <p>
                      UD自設24
                      小時技術支援熱線，由本地IT專業團隊以粵語、國語或英語與你溝通，服務靈活機動。除即時排憂解困之外，我們更會想多一步、預視未來，建構適合長期發展的一站式網絡解決方案，從頭指引客戶成長道路。
                    </p>
                  </div>
                  <div>
                    <h4>網絡安全</h4>
                    <p>
                      捍衛您的網絡安全從來都是我們最重要的任務。UD的網絡安全管理團隊已準備就緒，全力捍衛你的網上資產。我們的無間網絡監察、防火牆及伺服器設置、更新管理及數據備份等，均能確保你的網上業務安全無誤。
                    </p>
                  </div>
                  <div>
                    <h4>強勁網速</h4>
                    <p>
                      UD自置超過100Gb+的本地頻寬直達香港國際互聯網交換中心（HKIX），更備CN2高質量中港線路、CDN
                      及環球頻寬，讓你以高速、可靠穩定的網絡連繫香港、內地以至全球各地。
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <ProductCompareTable
              hostname={hostname}
              lng="tc"
              t={{
                "storageCompChart.viewSolution": "了解更多",
                "storageCompChart.use.title": "易於上手",
                "storageCompChart.usage.title": "用途",
                "storageCompChart.usage.opencloud": "即時架設配置",
                "storageCompChart.usage.multicloud": "企業系統方案",
                "storageCompChart.usage.hosting": "基本網站",
                "storageCompChart.usage.colocate": "企業系統",
                "storageCompChart.usage.cloud": "電子商貿平台，高安全性系統",
                "storageCompChart.traffic.title": "應付流量",
                "storageCompChart.title": "我應該用哪種雲端服務呢？",
                "storageCompChart.support.title": "售後支援",
                "storageCompChart.support.selfmanage": "自助管理平台",
                "storageCompChart.support.engineersupport": "24 x 7 技術支援",
                "storageCompChart.seePricing": "查看定價",
                "storageCompChart.seePackage": "查看定價",
                "storageCompChart.scale.title": "彈性",
                "storageCompChart.resources.title": "資源",
                "storageCompChart.resources.shared": "共享",
                "storageCompChart.resources.dedicated": "專屬",
                "storageCompChart.power.title": "運算力",
                "storageCompChart.opencloud": "OpenCloud雲端伺服器",
                "storageCompChart.multicloud": "跨雲管理服務",
                "storageCompChart.hosting": "雲端寄存及電郵",
                "storageCompChart.colocate": "伺服器托管",
                "storageCompChart.cloud": "雲端伺服器",
              }}
            />
            <div className="highlights_resources">
              <div className="pricingHighlights">
                <h3>收費特色</h3>
                <div className="highlights_resources-content">
                  <div className="highlights-container">
                    <div className="highlights-icon-container highlights-icon-payasyougo"></div>
                    <div className="highlights-text-container">
                      <h4>按用量收費</h4>
                      <p>按照業務需要隨時調整用量，增加靈活性</p>
                      <a
                        href={`https://${hostname}/tc/service/opencloud-server-openstack-instant-setup-asia-hongkong`}
                      >
                        OpenCloud收費
                      </a>
                    </div>
                  </div>
                  <div className="highlights-container">
                    <div className="highlights-icon-container highlights-icon-payless"></div>
                    <div className="highlights-text-container">
                      <h4>服務年期愈長 開支節省愈多</h4>
                      <p>較長年期服務計劃可讓你節省20%或以上開支</p>
                      <span>
                        <a
                          href={`https://${hostname}/tc/service/cloud-server/linux`}
                        >
                          雲端伺服器
                        </a>{" "}
                        |{" "}
                        <a
                          href={`https://${hostname}/tc/service/cloud-hosting/hongkong`}
                        >
                          雲端寄存
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="resourcePackages">
                <h3>資源組合</h3>
                <div className="highlights_resources-content">
                  <p>
                    特設多個資源組合，為你提供更大靈活性且更符合成本效益。凡惠顧資源組合，將可在未來訂單享受折扣。
                  </p>
                  <div className="resourcePackages-listing-container">
                    <a
                      href={`https://${hostname}/tc/service/network/global-cdn-content-delivery-network-international`}
                    >
                      <div className="resourcePackages-icon-container resourcePackages-icon-globalCDN"></div>
                      環球CDN
                    </a>
                    <a
                      href={`https://${hostname}/tc/service/network/china-cdn-content-delivery-network-icp`}
                    >
                      <div className="resourcePackages-icon-container resourcePackages-icon-chinaCDN"></div>
                      中國線路CDN
                    </a>
                    <a
                      href={`https://${hostname}/tc/service/network-cybersecurity-cloud-server-firewall`}
                    >
                      <div className="resourcePackages-icon-container resourcePackages-icon-cloudSecurity"></div>
                      雲端安全
                    </a>
                    <a
                      href={`https://${hostname}/tc/service/vas/media-streaming-service`}
                    >
                      <div className="resourcePackages-icon-container resourcePackages-icon-liveStreaming"></div>
                      現場串流直播服務
                    </a>
                    <a href={`https://${hostname}/tc/service/vas/web-design`}>
                      <div className="resourcePackages-icon-container resourcePackages-icon-webDesign"></div>
                      網頁設計
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="section-number">
              <div className="content-container">
                <h3>我們的數字</h3>
                <div className="number-items">
                  <div>
                    <p className="number-stat">100Gb+</p>
                    <p>本地頻寬專線直駁HKIX</p>
                  </div>
                  <div>
                    <p className="number-stat">20+</p>
                    <p>網絡經驗</p>
                  </div>
                  <div>
                    <p className="number-stat">300Gb+</p>
                    <p>中國及全球頻寬覆蓋</p>
                  </div>
                  <div>
                    <p className="number-stat">99.99%</p>
                    <p>在線時間保證</p>
                  </div>
                  <div>
                    <p className="number-stat">24x7</p>
                    <p>本地電話及線上技術支援</p>
                  </div>
                  <div>
                    <p className="number-stat">25k+</p>
                    <p>客戶遍佈全球</p>
                  </div>
                </div>
              </div>
            </div>

            <a
              href={`https://${hostname}/tc/about/data-center-hong-kong-infrastructure-server-node`}
              className="btn-blue"
            >
              我們的數據中心
            </a>
            <a
              href={`https://${hostname}/tc/about/why-udomain`}
              className="btn-white"
            >
              為何選用UD?
            </a>
            <a href={`https://${hostname}/tc/customer`} className="btn-white">
              客戶簡介
            </a>

            <a
              href={`https://${hostname}/${lng}/case-study/article/cloud-server-case-study-ztore-hong-kong-online-shop`}
            >
              <div className="testimonial">
                <p>
                  "一開始我們就選用<b>UD作為網購平台的雲端寄存公司</b>
                  ，負責開發及支援網絡架構、應付網絡安全和在線人流，讓我們騰出時間和人手專注發展業務。"
                </p>
                <p>Andrew，網上士多創辦人之一</p>
                <div className="image-container image-ztore" />
              </div>
            </a>
            <div className="caseStudy">
              <h3>客戶成功案例</h3>
              <input
                type="radio"
                name="tabset"
                id="security"
                value="security"
                onClick={onClick}
                checked={tabValue === "security"}
              />
              <input
                type="radio"
                name="tabset"
                id="cloud"
                value="cloud"
                onClick={onClick}
                checked={tabValue === "cloud"}
              />
              <input
                type="radio"
                name="tabset"
                id="solution"
                value="solution"
                onClick={onClick}
                checked={tabValue === "solution"}
              />
              <ul className="tabs">
                <label htmlFor="security">
                  <li>UD 網絡安全</li>
                </label>
                <label htmlFor="cloud">
                  <li>UD 雲端</li>
                </label>
                <label htmlFor="solution">
                  <li>UD 中國方案</li>
                </label>
              </ul>
              <div className="tab-content">
                <div className="tab-item tab-security">
                  <div className="casestudy-description active-security">
                    <a
                      href={`https://${hostname}/${lng}/case-study/article/penetration-test-case-study-enterprise-annual-audit-check`}
                    >
                      <h4>跨國集團週年網絡安全檢查</h4>
                      <p>滲透測試服務</p>
                    </a>
                  </div>
                  <div className="casestudy-description">
                    <a
                      href={`https://${hostname}/${lng}/case-study/article/ddos-pretection-case-study-us-foreign-exchange`}
                    >
                      <h4>美國外匯網站</h4>
                      <p>DDoS 防禦</p>
                    </a>
                  </div>
                  <div className="casestudy-description">
                    <a
                      href={`https://${hostname}/${lng}/case-study/article/penetration-test-case-study-hong-kong-school-system`}
                    >
                      <h4>香港學校和線上學習系統</h4>
                      <p>滲透測試服務</p>
                    </a>
                  </div>
                  <div className="casestudy-description">
                    <a
                      href={`https://${hostname}/${lng}/case-study/article/hacking-recovery-case-study-hk-lingerie-online-shop`}
                    >
                      <h4>香港知名內衣品牌</h4>
                      <p>駭客入侵修復</p>
                    </a>
                  </div>
                </div>
                <div className="tab-item tab-cloud">
                  <div className="casestudy-description  active-cloud">
                    <a
                      href={`https://${hostname}/${lng}/case-study/article/cloud-server-case-study-ztore-hong-kong-online-shop`}
                    >
                      <h4>士多 Ztore - 香港大型網上商店</h4>
                      <p>雲端伺服器及整合服務</p>
                    </a>
                  </div>
                  <div className="casestudy-description">
                    <a
                      href={`https://${hostname}/${lng}/case-study/article/cloud-server-case-study-hk-soft-drink-promotion-apps`}
                    >
                      <h4>香港飲料手機程式</h4>
                      <p>雲端伺服器</p>
                    </a>
                  </div>
                  <div className="casestudy-description">
                    <a
                      href={`https://${hostname}/${lng}/case-study/article/cloud-server-case-study-timable-hk-event-listing-startup`}
                    >
                      <h4>Timable - 香港 Startup 活動資訊網站</h4>
                      <p>雲端伺服器</p>
                    </a>
                  </div>
                </div>
                <div className="tab-item tab-solution">
                  <div className="casestudy-description  active-solution">
                    <a
                      href={`https://${hostname}/${lng}/case-study/article/china-routing-cdn-case-study-jwewlry-shop-entering-china`}
                    >
                      <h4>國際珠寶品牌發展中國業務</h4>
                      <p>中國線路CDN</p>
                    </a>
                  </div>
                  <div className="casestudy-description">
                    <a
                      href={`https://${hostname}/${lng}/case-study/article/dedicated-server-case-study-talkbox-china-voice-im-apps`}
                    >
                      <h4>Talkbox - 即時通訊手機程式</h4>
                      <p>專屬伺服器</p>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="banner-UDcloud">
              <div className="banner-content-container">
                <p>讓業務在雲端起飛</p>
                <div className="logo-ud"></div>
                <div className="graphic-banner-UDcloud"></div>
              </div>
            </div>

            <Wrap>
              <div className="serviceEnquiry">
                <Link
                  className="btn-onlineQuotation"
                  to="#allCloudService"
                  data-cta="Quotation-Online"
                >
                  所有雲端服務
                </Link>
                <a
                  className="btn-serviceEnquiry"
                  href={`https://${hostname}/${lng}/enquiry?enquiryType=campaign&campaignName=Cloud%20Pricing`}
                  data-cta="Service-Enquiry"
                >
                  服務查詢
                </a>
                <p className="phoneNumBlk">
                  歡迎致電客戶服務部熱線了解更多詳情
                  <br />
                  <span className="phoneNum">
                    <a href="tel:+85225547545" data-cta="CS-Call-Service">
                      (852) 2554 7545
                    </a>
                  </span>
                </p>
              </div>
            </Wrap>
          </div>
        </div>
      </main>
    </Layout>
  );
};

export default IndexPage;
